<p class="text-center">
    <i class="fal fa-circle-check fa-3x text-success"></i>
</p>

<p class="text-center">You have successfully scheduled the following cadence for your business:</p>

<div class="my-3">
    @if (recurrences) {
        <adapt-review-recurrences [scheduledRecurrences]="recurrences"></adapt-review-recurrences>
    }
</div>
